import { defineMessages } from 'react-intl';

const messages = defineMessages({
  // ContactDetails
  name: {
    id: 'ContactDetails.name',
    defaultMessage: 'Name',
  },
  namePlaceholder: {
    id: 'ContactDetails.namePlaceholder',
    defaultMessage: 'Your name',
  },
  email: {
    id: 'ContactDetails.email',
    defaultMessage: 'Email address',
  },
  emailPlaceholder: {
    id: 'ContactDetails.emailPlaceholder',
    defaultMessage: 'Your email address',
  },
  emailConfirm: {
    id: 'ContactDetails.emailConfirm',
    defaultMessage: 'Confirm email address',
  },
  emailConfirmPlaceholder: {
    id: 'ContactDetails.emailConfirmPlaceholder',
    defaultMessage: 'Confirm email address',
  },
  phone: {
    id: 'ContactDetails.phone',
    defaultMessage: 'Phone number',
  },
  phonePlaceholder: {
    id: 'ContactDetails.phonePlaceholder',
    defaultMessage: 'Your phone number',
  },
  phoneConfirm: {
    id: 'ContactDetails.phoneConfirm',
    defaultMessage: 'Confirm phone number',
  },
  phoneConfirmPlaceholder: {
    id: 'ContactDetails.phoneConfirmPlaceholder',
    defaultMessage: 'Confirm phone number',
  },
  preferredContactWay: {
    id: 'FormSelect.preferred_contact_way',
    defaultMessage: 'Preferred way to be contacted',
  },
  preferredContactWayPlaceholder: {
    id: 'ContactDetails.preferred_contact_wayPlaceholder',
    defaultMessage: 'Choose preferred contact way',
  },
  preferredContactHours: {
    id: 'FormSelect.availability_slots',
    defaultMessage: 'Preferred contact time',
  },
  preferredContactHoursPlaceholder: {
    id: 'ContactDetails.availability_slotsPlaceholder',
    defaultMessage: 'Choose time',
  },
  emailOptionPlaceholder: {
    id: 'ContactDetails.email_option_placeholder',
    defaultMessage: 'Email',
  },
  phoneOptionPlaceholder: {
    id: 'ContactDetails.phone_option_placeholder',
    defaultMessage: 'Phone call',
  },
  smsOptionPlaceholder: {
    id: 'ContactDetails.sms_option_placeholder',
    defaultMessage: 'SMS',
  },
  // Error
  MinimumCharacters: {
    id: 'Error.MinimumCharacters',
    defaultMessage: 'Please enter your whole name',
  },
  MaximumCharacters: {
    id: 'Error.MaximumCharacters',
    defaultMessage: 'Please enter a shorter version of your name',
  },
  NotValidEmail: {
    id: 'Error.NotValidEmail',
    defaultMessage: 'Please enter a valid email',
  },
  NonEqualEmail: {
    id: 'Error.NonEqualEmail',
    defaultMessage: 'The email addresses do not match',
  },
  PleaseSelectPreferredContactHours: {
    id: 'Error.PleaseSelectAvailabilitySlot',
    defaultMessage: 'Please select a timeslot for preferred contact',
  },
  PleaseSelectPreferredContactWay: {
    id: 'Error.PleaseSelectContactWay',
    defaultMessage: 'Please select a preferred way to be contacted',
  },
  NotValidPhoneNumber: {
    id: 'Error.NotValidPhoneNumber',
    defaultMessage: 'Please enter a valid phone number',
  },
  NonEqualPhoneNumber: {
    id: 'Error.NotEqualPhoneNumber',
    defaultMessage: 'The phone numbers do not match',
  },
  NotValidPostalCode: {
    id: 'Error.NotValidPostalCode',
    defaultMessage: 'Please enter a valid postal code',
  },
  YouMustConsent: {
    id: 'Error.YouMustConsent',
    defaultMessage:
      'You cannot proceed the sign-up without consenting. If you do not wish to consent, you can close the window in the upper right corner.',
  },
  '8-20': {
    id: 'ContactTimes.8-20',
    defaultMessage: 'Anytime',
  },
  '8-12': {
    id: 'ContactTimes.8-12',
    defaultMessage: '8:00 am - 12:00 noon',
  },
  '12-16': {
    id: 'ContactTimes.12-16',
    defaultMessage: '12:00 noon - 4:00 pm',
  },
  '16-20': {
    id: 'ContactTimes.16-20',
    defaultMessage: '4:00 pm - 8:00 pm',
  },
  postalCode: {
    id: 'ContactDetails.PostalCode',
    defaultMessage: 'Postal code',
  },
  postalCodePlaceholder: {
    id: 'ContactDetails.PostalCodePlaceholder',
    defaultMessage: 'Your postal code',
  },
});

export default messages;
